/**
 * Project Template JavaScript
 * Handles filtering, carousel, and interactive functionality
 */

document.addEventListener('DOMContentLoaded', function() {
  // Initialize MixItUp with retry mechanism
  let mixer;
  let retryCount = 0;
  const maxRetries = 10;
  
  function initializeMixItUp() {
    console.log('MixItUp available:', typeof mixitup !== 'undefined');
    console.log('Gallery element:', document.querySelector('.cd-gallery'));
    console.log('Mix elements found:', document.querySelectorAll('.mix').length);
    
    if (typeof mixitup !== 'undefined') {
      const galleryElement = document.querySelector('.cd-gallery');
      if (galleryElement) {
        mixer = mixitup('.cd-gallery', {
          selectors: {
            target: '.mix'
          },
          animation: {
            duration: 300
          }
        });
        console.log('MixItUp initialized successfully');
        return true;
      } else {
        console.log('Gallery element not found');
        return false;
      }
    } else {
      console.log('MixItUp library not loaded, retry:', retryCount);
      return false;
    }
  }
  
  // Try to initialize immediately
  if (!initializeMixItUp()) {
    // If not available, retry with intervals
    const retryInterval = setInterval(() => {
      retryCount++;
      if (initializeMixItUp() || retryCount >= maxRetries) {
        clearInterval(retryInterval);
        if (retryCount >= maxRetries) {
          console.log('MixItUp failed to load after', maxRetries, 'retries');
          // Fallback: Show all items without filtering
          const mixElements = document.querySelectorAll('.mix');
          mixElements.forEach(el => {
            el.style.display = 'block';
            el.style.visibility = 'visible';
          });
        }
      }
    }, 500);
  }

  // Connect radio buttons to filtering (with fallback)
  const radioInputs = document.querySelectorAll('ul.cd-filter-content.cd-filters.list li input[type="radio"]');
  radioInputs.forEach(function(input) {
    input.addEventListener('change', function() {
      if (this.checked) {
        const filterValue = this.getAttribute('data-filter');
        console.log('Filter changed to:', filterValue);
        
        if (mixer) {
          // Use MixItUp if available
          mixer.filter(filterValue);
        } else {
          // Fallback: Manual filtering
          const mixElements = document.querySelectorAll('.mix');
          mixElements.forEach(function(el) {
            if (filterValue === '' || el.classList.contains(filterValue.replace('.', ''))) {
              el.style.display = 'block';
              el.style.visibility = 'visible';
            } else {
              el.style.display = 'none';
            }
          });
        }
      }
    });
  });

  // Handle content type checkboxes (Projects, Videos, Documents)
  const contentTypeCheckboxes = document.querySelectorAll('.custom-checkbox-input:not(.project-filter)');
  contentTypeCheckboxes.forEach(function(input) {
    input.addEventListener('change', function(e) {
      applyContentTypeFilters();
    });
  });

  // Handle project filter checkboxes (All, Pool, Patio, etc.)
  const projectFilterCheckboxes = document.querySelectorAll('.custom-checkbox-input.project-filter');
  projectFilterCheckboxes.forEach(function(input) {
    input.addEventListener('change', function(e) {
      const allCheckbox = document.querySelector('#project-checkbox-all');
      const isAllCheckbox = this.id === 'project-checkbox-all';
      
      if (isAllCheckbox && this.checked) {
        // If "All" is checked, uncheck all other project filters
        const otherCheckboxes = document.querySelectorAll('.custom-checkbox-input.project-filter:not(#project-checkbox-all)');
        otherCheckboxes.forEach(function(checkbox) {
          checkbox.checked = false;
        });
      } else if (!isAllCheckbox && this.checked) {
        // If any individual filter is checked, uncheck "All"
        if (allCheckbox) {
          allCheckbox.checked = false;
        }
      }
      
      applyProjectFilters();
    });
  });


  function applyContentTypeFilters() {
    const checkedBoxes = document.querySelectorAll('.custom-checkbox-input:not(.project-filter):checked');
    const filterValues = Array.from(checkedBoxes).map(function(checkbox) {
      return checkbox.getAttribute('data-filter');
    });
    
    console.log('Content type filters applied:', filterValues);
    
    // Store content type filters for combined filtering
    window.contentTypeFilters = filterValues;
    applyCombinedFilters();
  }

  function applyProjectFilters() {
    const checkedBoxes = document.querySelectorAll('.custom-checkbox-input.project-filter:checked');
    const filterValues = Array.from(checkedBoxes).map(function(checkbox) {
      return checkbox.getAttribute('data-filter');
    });
    
    console.log('Project filters applied:', filterValues);
    
    // Check if "All" is checked
    const allCheckbox = document.querySelector('#project-checkbox-all');
    if (allCheckbox && allCheckbox.checked) {
      // If "All" is checked, clear other project filters
      const otherCheckboxes = document.querySelectorAll('.custom-checkbox-input.project-filter:not(#project-checkbox-all)');
      otherCheckboxes.forEach(function(checkbox) {
        checkbox.checked = false;
      });
      window.projectFilters = []; // Empty array means show all
    } else {
      // If specific filters are checked, uncheck "All"
      if (allCheckbox) {
        allCheckbox.checked = false;
      }
      window.projectFilters = filterValues;
    }
    
    applyCombinedFilters();
  }

  // New advanced filtering function that works with separated content sections
  function applyAdvancedFiltering() {
    const contentTypeFilters = window.contentTypeFilters || [];
    const projectFilters = window.projectFilters || [];
    
    console.log('🔍 Advanced filtering - Content types:', contentTypeFilters, 'Project filters:', projectFilters);
    
    // Filter each content section separately
    const contentSections = [
      // Treat regular project cards as a group
      { selector: '.mix:not(.videos-section .mix):not(.documents-section .mix):not(.comparison-section)', type: 'projects' },
      // Treat comparison section independently so project filters do not hide it
      { selector: '.comparison-section', type: 'comparison' },
      { selector: '.videos-section', type: 'videos' },
      { selector: '.documents-section', type: 'documents' }
    ];
    
    contentSections.forEach(function(section) {
      const mixElements = document.querySelectorAll(section.selector);
      console.log(`📦 Found ${mixElements.length} ${section.type} elements to filter`);
      
      mixElements.forEach(function(element, index) {
        let shouldShow = true;
        
        // Get the element's filter classes
        const elementClasses = Array.from(element.classList);
        console.log(`📋 ${section.type} element ${index + 1} classes:`, elementClasses);
        
        // Check content type filters (Projects, Videos, Documents)
        if (contentTypeFilters.length > 0) {
          const matchesContentType = contentTypeFilters.some(function(filterValue) {
            const cleanFilter = filterValue.replace('.', '');
            const hasClass = elementClasses.includes(cleanFilter);
            console.log(`  ✅ Content type filter "${cleanFilter}":`, hasClass);
            return hasClass;
          });
          shouldShow = shouldShow && matchesContentType;
          console.log(`  🎯 Content type match for ${section.type} element ${index + 1}:`, matchesContentType);
        }
        
        // Check project filters (Pool, Patio, etc.) - only for projects section
        if (section.type === 'projects' && projectFilters.length > 0) {
          const matchesProject = projectFilters.some(function(filterValue) {
            const cleanFilter = filterValue.replace('.', '');
            
            // Check if the element has the filter class
            const hasClass = elementClasses.includes(cleanFilter);
            
            // Also check if the filter is in the element's filter_for data attribute (for space-separated values)
            const filterForAttr = element.getAttribute('data-filter-for') || '';
            const filterForValues = filterForAttr.split(' ').map(function(val) { return val.trim(); });
            const hasFilterInData = filterForValues.includes(cleanFilter);
            
            const matches = hasClass || hasFilterInData;
            console.log(`  ✅ Project filter "${cleanFilter}":`, matches, `(element classes: ${elementClasses.join(', ')}, filter_for: ${filterForAttr}, filter_values: [${filterForValues.join(', ')}])`);
            return matches;
          });
          shouldShow = shouldShow && matchesProject;
          console.log(`  🎯 Project match for ${section.type} element ${index + 1}:`, matchesProject);
        } else if (section.type === 'projects') {
          // If no project filters are selected (All is checked), show all project content
          console.log(`  🌟 No project filters - showing all project content for ${section.type} element ${index + 1}`);
        } else if (section.type === 'comparison') {
          // Comparison section should only follow content-type filters and ignore project filters entirely
          console.log('  🔎 Comparison section processed with content-type filters only');
        }
        
        // Apply visibility with smooth transitions
        if (shouldShow) {
          // Remove hidden class first, then add visible class with delay
          element.classList.remove('mix-hidden');
          setTimeout(() => {
            element.classList.add('mix-visible');
          }, index * 50); // Staggered delay based on element index
          console.log(`  ✅ ${section.type} element ${index + 1} will be shown`);
        } else {
          // Remove visible class first, then add hidden class
          element.classList.remove('mix-visible');
          element.classList.add('mix-hidden');
          console.log(`  ❌ ${section.type} element ${index + 1} will be hidden`);
        }
      });
    });
    
    console.log('🏁 Advanced filtering complete');
  }

  function applyCombinedFilters() {
    // Use the new advanced filtering function
    applyAdvancedFiltering();
  }


  // Quote button click handler
  const quoteButtons = document.querySelectorAll('.quote_btn a');
  quoteButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      document.body.classList.add('active_quote');
      const quoteForm = document.querySelector('.qoute_form');
      if (quoteForm) {
        quoteForm.classList.add('active');
      }
    });
  });

  // Close form button click handler
  const closeFormButtons = document.querySelectorAll('.close_form a');
  closeFormButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      document.body.classList.remove('active_quote');
      const quoteForm = document.querySelector('.qoute_form');
      if (quoteForm) {
        quoteForm.classList.remove('active');
      }
    });
  });

  // Image carousel functionality - Optimized for instant switching
  // Cache all carousel data upfront to avoid repeated DOM queries
  const carouselData = new Map();
  
  // Pre-cache all carousel elements and their data
  const projectCards = document.querySelectorAll('.project-card');
  projectCards.forEach(function(projectCard) {
    const mainImage = projectCard.querySelector('.main-project-image');
    const dots = projectCard.querySelectorAll('.image-carousel-dots .dot');
    const hiddenImages = projectCard.querySelectorAll('.hidden-carousel-images img');
    
    // Cache original src
    if (mainImage && !mainImage.getAttribute('data-original-src')) {
      mainImage.setAttribute('data-original-src', mainImage.getAttribute('src'));
    }
    
    // Cache image sources by index for faster lookup
    const imageSources = new Map();
    const preloadedImages = new Map();
    
    // Main image
    const mainSrc = mainImage ? (mainImage.getAttribute('data-original-src') || mainImage.getAttribute('src')) : '';
    imageSources.set('1', mainSrc);
    
    // Preload main image
    if (mainSrc) {
      const img = new Image();
      img.src = mainSrc;
      preloadedImages.set('1', img);
    }
    
    // Hidden images
    hiddenImages.forEach(function(img) {
      const index = img.getAttribute('data-index');
      const src = img.getAttribute('data-carousel-src');
      if (index && src) {
        imageSources.set(index, src);
        
        // Preload the image for instant switching
        const preloadImg = new Image();
        preloadImg.src = src;
        preloadedImages.set(index, preloadImg);
      }
    });
    
    carouselData.set(projectCard, {
      mainImage: mainImage,
      dots: dots,
      imageSources: imageSources,
      preloadedImages: preloadedImages
    });
  });

  // Optimized dot click handler for instant switching
  const carouselDots = document.querySelectorAll('.image-carousel-dots .dot');
  carouselDots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      const imageIndex = this.getAttribute('data-image');
      const projectCard = this.closest('.project-card');
      const data = carouselData.get(projectCard);
      
      if (!data || !data.mainImage) return;
      
      // Remove active class from all dots in this project
      data.dots.forEach(d => d.classList.remove('active'));
      
      // Add active class to clicked dot
      this.classList.add('active');
      
      // Get image source from cache and switch instantly
      const newImageSrc = data.imageSources.get(imageIndex);
      
      if (newImageSrc) {
        // Check if image is already preloaded for instant switching
        const preloadedImg = data.preloadedImages.get(imageIndex);
        if (preloadedImg && preloadedImg.complete) {
          // Instant switch for preloaded images
          data.mainImage.src = newImageSrc;
        } else {
          // Fallback to normal switching
          data.mainImage.setAttribute('src', newImageSrc);
        }
      }
    });
  });

  // Optimized arrow navigation for carousels
  document.querySelectorAll('.project-card .carousel-arrow').forEach(function(btn){
    btn.addEventListener('click', function(e){
      if (e) { e.preventDefault(); e.stopPropagation(); }
      const projectCard = this.closest('.project-card');
      if (projectCard && projectCard.dataset.carouselLock === '1') return;
      if (projectCard) projectCard.dataset.carouselLock = '1';
      
      const data = carouselData.get(projectCard);
      if (!data || !data.dots || data.dots.length === 0) return;
      
      const dots = data.dots;
      const activeIdx = Math.max(0, Array.from(dots).findIndex(d => d.classList.contains('active')));
      let targetIdx = activeIdx;
      
      if (this.classList.contains('prev')) {
        targetIdx = (activeIdx - 1 + dots.length) % dots.length;
      } else {
        targetIdx = (activeIdx + 1) % dots.length;
      }
      
      // Trigger the click on the target dot to reuse existing logic
      dots[targetIdx].click();
      
      // Reduce lock timeout for faster response
      if (projectCard) setTimeout(function(){ projectCard.dataset.carouselLock = '0'; }, 50);
    });
  });

  // Initialize FlexSlider if available
  if (typeof $.fn.flexslider !== 'undefined') {
    const flexsliders = document.querySelectorAll('.flexslider');
    flexsliders.forEach(function(slider) {
      $(slider).flexslider({
        animation: "slide"
      });
    });
  }
});

// Popup filter main click handler
document.addEventListener('click', function(e) {
  if (e.target.closest('.popup_filter_main')) {
    e.preventDefault();
    const comparisonPopup = document.querySelector('.comparison_popup');
    const comparisonOverlay = document.querySelector('.comparison_overlay');
    if (comparisonPopup) {
      comparisonPopup.classList.add('active');
    }
    if (comparisonOverlay) {
      comparisonOverlay.classList.add('active');
    }
  }
});

// Comparison overlay click handler
document.addEventListener('click', function(e) {
  if (e.target.classList.contains('comparison_overlay')) {
    e.preventDefault();
    const comparisonPopup = document.querySelector('.comparison_popup');
    const comparisonOverlay = document.querySelector('.comparison_overlay');
    if (comparisonPopup) {
      comparisonPopup.classList.remove('active');
    }
    if (comparisonOverlay) {
      comparisonOverlay.classList.remove('active');
    }
  }
});

// Comparison popup close button click handler
document.addEventListener('click', function(e) {
  if (e.target.closest('.comparison_popup .close')) {
    e.preventDefault();
    const comparisonPopup = document.querySelector('.comparison_popup');
    const comparisonOverlay = document.querySelector('.comparison_overlay');
    if (comparisonPopup) {
      comparisonPopup.classList.remove('active');
    }
    if (comparisonOverlay) {
      comparisonOverlay.classList.remove('active');
    }
  }
});
